module.exports = __webpack_public_path__ + "static/media/pk.d2c8984a.svg";